import { Entity } from '@data-client/rest';
class GeoCountryEntity extends Entity {
    constructor() {
        super(...arguments);
        this.countryCode = null;
        this.id = 0;
        this.name = null;
    }
    pk() {
        return this.id.toString();
    }
}
GeoCountryEntity.key = 'GeoCountry';
export { GeoCountryEntity };
